// import dayjs from '../lib/day.min.js'

export const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
export const formatLocation = (longitude, latitude) => {
    if (typeof longitude === 'string' && typeof latitude === 'string') {
        longitude = parseFloat(longitude)
        latitude = parseFloat(latitude)
    }

    longitude = longitude.toFixed(2)
    latitude = latitude.toFixed(2)

    return {
        longitude: longitude.toString().split('.'),
        latitude: latitude.toString().split('.')
    }
}
//时间戳转时间格式
export const timeToDate = time => {
    var date = new Date(time * 1000);//如果date为13位不需要乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y + M + D + h + m + s;
}
// const formatDatetimeS=date=>{
//   var m = moment( date|| new Date() );
//   return m.format('MM月DD日 HH:mm')
// }

//用户姓名汉字 2-10位
export const inputCheckChineseName = name => {
    if ((/^[\u4e00-\u9fa5]{2,10}$/.test(name))) {
        return true;
    }
    return false;
}

export const isCardCheck = card => {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card)) {
        return true;
    }
    return false;
}

export function existy(variableName) {
    try {
        if (typeof (variableName) == "undefined") {
            return false;
        } else {
            return true;
        }
    } catch (e) {
        return false;
    }

}

export function isValid(value) {
    if (value === null || value == '') {
        return false;
    }
    return existy(value);
}

//验证手机号
export function inputCheckPhone(value) {
    if ((/^1[3456789]\d{9}$/.test(value))) {
        return true;
    }
    return false;
}
// function getDateMinute(time){
//     return dayjs(time).format("HH:mm")
// }
// function getCountDown(time){
//     var endTime=dayjs(time).add(30,'minute').unix();
//     var nowDate = dayjs().unix();
//     var diff=endTime-nowDate;
//     if(diff<=0) return '';
//     let minute = parseInt(diff/60);
//     let second = parseInt(diff%60);
//     return formatNumber(minute) + '分' + formatNumber(second)+'秒'
// }

//把obj对象里的值覆盖到newobj里面
export function deepCopy(newobj, obj) {
    if (typeof obj != 'object') {
        return obj;
    }
    for (var attr in obj) {
        var a = {};
        if (newobj[attr]) {
            a = newobj[attr];
        }
        newobj[attr] = deepCopy(a, obj[attr]);
    }
    return newobj;
}
export function getQueryString(name,url=window.location.serach) {
    var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
    var r = url.substr(1).match(reg)
    if (r != null) {
        return r[2]
    }
    return null;
}
//货币格式化
export function formatMoney(number, places, symbol, thousand, decimal) {
    number = number || 0;
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "￥";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}

// 商品列表排列方式  1：多个一行 2：一个一行
export const goodsStyle = 2;